import { render, staticRenderFns } from "./PatentsScreen.vue?vue&type=template&id=3a4ccd14&scoped=true&"
import script from "./PatentsScreen.vue?vue&type=script&lang=js&"
export * from "./PatentsScreen.vue?vue&type=script&lang=js&"
import style0 from "./PatentsScreen.vue?vue&type=style&index=0&id=3a4ccd14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ccd14",
  null
  
)

export default component.exports